import { reactive, toRefs, readonly } from 'vue'

export interface Dialog {
  id: number
  component: unknown
  props?: Record<string, unknown>
  listeners?: Record<string, ((...args: any[]) => void | Promise<void>) | ((...args: any[]) => void | Promise<void>)[]>
  maxWidth?: string | number
  // Opens fullscreen (with a close button) on phone-sized screens.
  fullscreenOnMobile?: boolean
}

const state = reactive({
  dialogs: [] as Dialog[],
})

let id = 0

export const useDialogStore = () => {
  const { dialogs } = toRefs(state)

  const openDialog = ({ component, props = {}, listeners = {}, maxWidth = 'none', fullscreenOnMobile = false }: Omit<Dialog, 'id'>) => {
    state.dialogs.push({ id: ++id, component, props, listeners, maxWidth, fullscreenOnMobile })
  }

  const closeTopDialog = () => {
    if (state.dialogs.length > 0) {
      state.dialogs.pop()
    }
  }

  const closeAllDialogs = () => {
    state.dialogs = []
  }

  return {
    dialogs: readonly(dialogs),
    openDialog,
    closeTopDialog,
    closeAllDialogs,
  }
}